import React, { useEffect, useState } from 'react';
import Segitiga from '../components/img/Segitiga.png';

const QTEBar = ({ setBallSpeed, isBallHeld, resetQTE }) => {
    const [pointerPos, setPointerPos] = useState(0);
    const [direction, setDirection] = useState(1);
    const [isRunning, setIsRunning] = useState(false);

    useEffect(() => {
        let interval;
        if (isRunning) {
            interval = setInterval(() => {
                setPointerPos((prev) => {
                    if (prev >= 80) setDirection(-1);
                    if (prev <= 0) setDirection(1);
                    return prev + direction * 2;
                });
            }, 50);
        } else {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [isRunning, direction]);

    useEffect(() => {
        let dy;
        if (pointerPos < 40) dy = 5;
        else if (pointerPos < 60) dy = 3;
        else dy = 5;
        setBallSpeed(dy);
        setIsRunning(isBallHeld);
    }, [isBallHeld, pointerPos]);

    useEffect(() => {
        if (resetQTE) {
            setPointerPos(0);
            setDirection(1);
        }
    }, [resetQTE]);

    return (
        <div className="relative border rounded-full shadow-lg lg:w-12 lg:h-72 sm:w-8 sm:h-48">
            <div className="h-2/5 rounded-t-full bg-gradient-to-b from-red-500 to-red-700 "></div>
            <div className="h-1/5 bg-gradient-to-b from-green-500 to-green-500 "></div>
            <div className="h-2/5 rounded-b-full bg-gradient-to-b from-red-500 to-red-700 "></div>
            <img 
                src={Segitiga} 
                alt="Pointer" 
                className="pointer absolute ml-5 lg:w-8 md:w-5 sm:w-5" 
                style={{ bottom: `${pointerPos}%`, left: '50%', transform: 'translateX(-50%)' }} 
            />
        </div>
    );
};

export default QTEBar;
